
import axios from "axios";
import ErrorParser from '../../services/error.parser';

const ObservationsService = {
  observations: async function () {
    const requestData = {
      method: "get",
      url: "/api/observations"
    };
    try {
      const response = await axios(requestData);
      return JSON.parse(response.data);
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  }, 
  observationsasync: async function () {
    const requestData = {
      method: "get",
      url: "/api/observationsasync"
    };
    try {
      const response = await axios(requestData);
      return JSON.parse(JSON.stringify(response.data));
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  }, 
  sensorobservations: async function (filtering) {
    const requestData = {
      method: "get",
      url: "/api/observations/maxutc/" + filtering.sensorid + "/provider/" + filtering.providerid
    };
    try {
      const response = await axios(requestData);
      return JSON.parse(response.data);
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },

  sensorobservationsTS: async function (filtering) {
    const requestData = {
      method: "get",
      url: "/api/observations/fromutc/" + filtering.datefrom + "/toutc/" + filtering.dateto + "/id/" + filtering.sensorid + "/provider/" + filtering.providerid
    };
    try {
      const response = await axios(requestData);
      return JSON.parse(response.data);
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  sensorobservationsOld: async function (filtering) {
    const requestData = {
      method: "get",
      url: "/api/observations/minutc/" + filtering.sensorid + "/provider/" + filtering.providerid
    };
    try {
      const response = await axios(requestData);
      return JSON.parse(response.data);
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  sensorobservationsCsv: async function (filtering) {

    const requestData = {
      method: "post",
      url: "/api/observations/csv",
      responsetype: "blob",
      data: filtering
    };
    try {
      const response = await axios(requestData);

      if(response.data === ""){
        return false;
      }
      var fileURL = window.URL.createObjectURL(new Blob([response.data]));
      var fileLink = document.createElement('a');

      fileLink.href = fileURL;
      fileLink.setAttribute('download', 'eksport.csv');
      document.body.appendChild(fileLink);

      fileLink.click();

      return true;

    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  sensorobservationsCsvArray: async function (filteringArr) {
    let requestData;
    let requestDataArr = [];
    for (let i = 0; i < filteringArr.length; i++) {
      
      requestData = {
        method: "post",
        url: "/api/observations/csvnew",
        responsetype: "blob",
        data: filteringArr[i]
      };
      requestDataArr.push(requestData);
    }
    
    let response;
    let responseTmp;
    response = await axios(requestDataArr[0]);

    try {
      
      for (let i = 1; i < requestDataArr.length; i++) {
        responseTmp = await axios(requestDataArr[i]);
        // break the textblock into an array of lines
        var lines = responseTmp.data.split('\n');
        // remove one line, starting at the first position
        lines.splice(0,1);
        // join the array back into a single string
        responseTmp.data = lines.join('\n');
        response.data = response.data + responseTmp.data;
        
      }

      if(response.data === ""){
        return false;
      }
      var fileURL = window.URL.createObjectURL(new Blob([response.data]));
      var fileLink = document.createElement('a');

      fileLink.href = fileURL;
      fileLink.setAttribute('download', 'eksport.csv');
      document.body.appendChild(fileLink);

      fileLink.click();

      return true;

    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
    
  },

  sensorobservationsCsvArrayWithMissingAgg: async function (filteringArr) {
    let requestData;
    let requestDataArr = [];

    for (let i = 0; i < filteringArr.length; i++) {
      requestData = {
        method: "post",
        url: "/api/observations/csvnewagg",
        responsetype: "blob",
        data: filteringArr[i]
      };
      requestDataArr.push(requestData);
    }
    
    let response;
    let responseTmp;
    try {
      response = await axios(requestDataArr[0]);
      for (let i = 1; i < requestDataArr.length; i++) {
        responseTmp = await axios(requestDataArr[i]);
        // break the textblock into an array of lines
        var lines = responseTmp.data.split('\n');
        // remove one line, starting at the first position
        lines.splice(0,1);
        // join the array back into a single string
        responseTmp.data = lines.join('\n');
        response.data = response.data + responseTmp.data;
        
      }
      let AggLevel = filteringArr[0].AggLevel;
      let unit;
      if(AggLevel == "hourly"){
        unit = 3600 * 1;
      }
      else if(AggLevel == "daily"){
        unit = 3600 * 24;
      }
      else if(AggLevel == "weekly"){
        unit = 3600 * 24 * 7;
      }
      var array = response.data.split("\n") ;
      for(let i = 0 ; i < array.length ; i++){
        array[i] = array[i].split(";");
      }
      let tmp = [];
      let Arr2= [];
      let counter = -1;

      for(let j = 0 ; j < array.length - 1 ; j++){
        if(j <= 1){
          Arr2.push([...array[j]]);
          counter = counter +1;
        }
        else if(j > 1 && array[j] !== undefined ){
          let var1 = parseInt(array[j][24]);
          let var2 = parseInt(Arr2[counter][24]);

          if(var1 - var2 > unit){

            tmp.push([...Arr2[counter]]);
            tmp[0][24] = parseInt(tmp[0][24]) + unit; //insert row data for next hour
            tmp[0][8] = NaN; //insert null value
            Arr2.push([...tmp[0]]);
            tmp.pop();
            counter = counter + 1; 
            j = j-1;
            continue;
          }
          else{
            Arr2.push(array[j]);
            counter = counter + 1;

          }
        }
        
      }
      response.data = "" + Arr2.toString() ;
      response.data = response.data.replaceAll(/(\r\n,|\r,|\n,)/g, '\n');
      response.data = response.data.replaceAll(",", ";");
      
      if(response.data === ""){
        return false;
      }
      
      var fileURL = window.URL.createObjectURL(new Blob([response.data]));
      var fileLink = document.createElement('a');

      fileLink.href = fileURL;
      fileLink.setAttribute('download', 'eksport.csv');
      document.body.appendChild(fileLink);

      fileLink.click();

      return true;

    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  aggregeatedobservations: async function (filtering) {

    const requestData = {
      method: "post",
      url: "/api/observations/aggregated",
      data: filtering
    };
    try {
      const response = await axios(requestData);
      return JSON.parse(response.data);
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  last2Haggregeatedobservations: async function () {
    const requestData = {
      method: "post",
      url: "/api/observations/aggregatedlast24h",
      data: filtering
    };
    try {
      const response = await axios(requestData);
      return JSON.parse(response.data);
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  lastPeriodicStatistics: async function (filtering) {

    const requestData = {
      method: "post",
      url: "/api/observations/lastPeriodicStatistics",
      data: filtering
    };
    try {
      const response = await axios(requestData);
      return JSON.parse(response.data);
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
};

export default ObservationsService;

